import { TextLink } from './TextLink';
import styled from 'styled-components';
import { truncateText } from '@/utils/truncateText';
import { Meta } from '@/components/Modules/Article/Meta';
import { FlexRow, FlexCol } from '@zopauk/react-components';
import type { AuthorForPostListFragment } from '@/utils/dato/generated';

type PostProps = {
  categories: {
    title?: string | null;
    slug?: string | null;
  }[];
  author?: AuthorForPostListFragment;
  image?: React.ReactElement;
  excerpt?: string | null;
  title?: string | null;
  date?: string | null;
  slug?: string | null;
};

const Wrapper = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f1f7;
`;

export const Post = ({ excerpt, image, title, slug, ...article }: PostProps) => (
  <Wrapper className="mb-8">
    <FlexRow cols={12}>
      <FlexCol xs="fill">
        <h3 className="text-base font-serif lg:text-lg font-semibold mb-3">
          <TextLink href={`/blog/article/${slug}`}>{title}</TextLink>
        </h3>
        {excerpt ? <p className="mb-6">{truncateText(excerpt, 128)}</p> : null}
        <Meta article={article} />
      </FlexCol>
      {image ? (
        <FlexCol xs="hidden" m={3}>
          <TextLink href={`/blog/article/${slug}`}>{image}</TextLink>
        </FlexCol>
      ) : null}
    </FlexRow>
  </Wrapper>
);
